module.exports = __webpack_public_path__ + "static/media/X.e16ce0cc.svg";